/*
 * Copyright (c) 2023
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Static, TSchema } from "@sinclair/typebox"
import { Value } from "@sinclair/typebox/value"

export function castOrDefault<S extends TSchema>(schema: S, value: unknown, defaultValue: Static<S>): Static<S> {
    return Value.Check(schema, value) ? Value.Cast(schema, value) : defaultValue
}
